import React, { Fragment, useState, useEffect } from "react";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import Calendar from "react-calendar";
import Select from "react-select";
import "react-calendar/dist/Calendar.css";
import "../../style/calendarclass.css";
import moment from "moment";
import { Table, Checkbox } from "semantic-ui-react";
import Multiselect from 'multiselect-react-dropdown';
let dayArr = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
 
const FormAddHolidayCalender = (props) => {
  const { inputFields, formValidation ,holidaycal ,handleCheckCheckBox,WeekdayId,selectedDesig,selectedYearList,selecteddepartment} = props;
  const [calenderDate] = useState(new Date());
  let options=[];
  let options1=[];
  let options2=[];
  let optionscale=[];
  let holidaylist=[];
  if (Array.isArray(holidaycal)) {
    holidaycal.map(function (hol){
      holidaylist.push(moment(hol.holidayDate).format('DD-MM-YYYY'));
    })
  }
  if (Array.isArray(inputFields)) {
    inputFields.map(function (desig) {
      if(desig.type=="multipleselect" && desig.option && desig.option.length >0)
      {
        desig.option.map((el,i) =>{
          options.push({value: el.officeLocationId, label: el.address }); 
        })
       
      }
      else if(desig.type=="multipleselect1" && desig.option && desig.option.length >0)
      {
        desig.option.map((el,i) =>{
          options1.push({value: el.departmentId, label: el.departmentName }); 
        })
       
      }
      else if(desig.type=="select" && desig.option && desig.option.length >0)
      {
        desig.option.map((el,i) =>{
          options2.push({value: el.calanderyearId, label: el.description }); 
        })
       
      }
    })
  }
  // const [date, setDate] = useState();
  // const [day, setDay] = useState("");
  // const [year, setYear] = useState("");

  // const onChange = (date) => {
  //   // setDate(date);
  //   setDate(date.getDate());
  //   setDay(dayArr[date.getDay()]);
  //   setYear(date.getFullYear());
  //   props.handleOnchangeDate(date);
  // };

  // useEffect(() => {
  //   if (props.formData !== undefined) {
  //     let incomingDate = new Date(props.formData.val.type2);
  //     setDate(incomingDate.getDate());
  //     setDay(dayArr[incomingDate.getDay()]);
  //     setYear(incomingDate.getFullYear());
  //   }
  // }, [props.formData]);

  const users = [
    {id: 1, name: 'Sunday'},
    {id: 2, name: 'Monday'},
    {id: 3, name: 'Tuesday'},
    {id: 4, name: 'Wednesday'},
    {id: 5, name: 'Thursday'},
    {id: 6, name: 'Friday'},
    {id: 7, name: 'Saturday'},
  ];
  
  const TableRow = React.memo(({ selected, id, label }) => {
   
    var bbb=selected.includes(String(id)) ? true :false ;
    return (
      <Table.Row>
        <Table.Cell>
          <Checkbox className="checkboxn"
            id={id}
            checked={selected.includes(String(id)) ? true :false} 
            onChange={(e) => {
              handleCheckCheckBox(e.target.id,0,e);
            }}
          />
        </Table.Cell>
        <Table.Cell>{label}</Table.Cell>
      </Table.Row>
    );
  })
  return (
    <Fragment>
      <Form onSubmit={props.handleSubmit}>
        <Row form>
          <Col md={4}>
            <Calendar
              onChange={(date) => props.handleOnchangeDate(date)}
              value={calenderDate}
              tileClassName={({ date, view }) => {
                if(holidaylist.find(x=>x===moment(date).format("DD-MM-YYYY"))){
                 return  'highlight'
                }
              }}
              disabledKeyboardNavigation
              locale='en-IN'
            />
          <Table>
      <Table.Header>
      <Table.Row>
        <Table.HeaderCell />
        <Table.HeaderCell>Set Non Working Days (Recurring)</Table.HeaderCell>
      </Table.Row>
      </Table.Header>
      <Table.Body>
          {users.map((user) => 
              <TableRow 
                key={user.id} 
                id={user.id}
                label={user.name}  
                selected={WeekdayId}
              />
          )}
      </Table.Body>
    </Table>
          </Col>
          <Col md={8}>
            {inputFields !== undefined
              ? inputFields.map((inputField, i) => {
                  return (
                    <FormGroup key={i}>
                      { inputField.type != "multipleselect" &&  inputField.type != "multipleselect1" &&  inputField.type != "select"? (<Fragment> <Label>{inputField.label}</Label>
                      <Input
                        type={inputField.type}
                        placeholder={inputField.placeholder}
                        onChange={(e) => {
                          inputField.handleOnChange(e.target.value);
                        }}
                        value={
                          props.formData.val != ''
                            ? props.formData.val[inputField.name]
                            : ""
                        }
                      />
                      
                      {Object.keys(formValidation).length !== 0 &&
                        !formValidation?.[inputField.name]?.isValid && (
                          <span className=" " style={{ color: "red" }}>
                            {formValidation?.[inputField.name]?.errorMessage}
                          </span>
                        )}</Fragment>) : (inputField.type === "multipleselect" ? (inputField.option.length >0 ? (
                 
                          <Fragment>
         <Label>{inputField.label}</Label>
                
                   <Multiselect
options={options} 
selectedValues={selectedDesig} 
onSelect={(e) => {
  inputField.handleOnChange(e[e.length-1].value,0,e);
}}

displayValue="label" // Property name to display in the dropdown options
/>
                          </Fragment>
                        ) : null) : (inputField.type === "multipleselect1" ? (inputField.option.length >0 ? (
                 
                          <Fragment>
         <Label>{inputField.label}</Label>
                   {/* <Select style={{color:"black"}}
                 isMulti  options={options1}  onChange={(e) => {
                   inputField.handleOnChange(e[e.length-1].value,0);
                 }}>
                    
                  
                   </Select> */}
                                  <Multiselect
options={options1} 
selectedValues={selecteddepartment} 
onSelect={(e) => {
  inputField.handleOnChange(e[e.length-1].value,0,e);
}}

displayValue="label" // Property name to display in the dropdown options
/>
                          </Fragment>
                        ) : null) :( <Fragment>
                          <Label>{inputField.label}</Label>
                          {/* <Input
                            type={inputField.type}
                            placeholder={inputField.placeholder}
                            onChange={(e) => {
                              inputField.handleOnChange(e.target.value);
                            }}
                          >
                            <option value="0">----Select----</option>
                            {inputField.option.map((el, i) => (
                             <option 
                              key={i} 
                              value={el[inputField.displayData["id"]]}
                              >
                                {el[inputField.displayData["selectedData"]]}
                              </option>
                            ))}
                          </Input> */}
                          <Select
        className="basic-single"
        classNamePrefix="select"
        defaultValue={options2[0]}
        onChange={(e) => {
          inputField.handleOnChange(e.value,e.label);
        }} 
        value={selectedYearList}
        isSearchable={true}
        name="color"
        options={options2}
      />
                        </Fragment>)))} 
                     



                         


                    </FormGroup>
                  );
                })
              : null}
              
            <Row form>
              <Col md={4}>
                <FormGroup>
                  <Label>Date</Label>
                  <Input
                    type="text"
                    placeholder="Select Date"
                    // value={date}
                    value={props.calenderDate.date}
                    disabled
                    required
                    // value={props.formData ? props.formData.val[val.name] : null}
                  />
                  {Object.keys(formValidation).length !== 0 &&
                    !formValidation?.date?.isValid && (
                      <span className=" " style={{ color: "red" }}>
                        {formValidation?.date?.errorMessage}
                      </span>
                    )}
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label>Day</Label>
                  <Input
                    type="text"
                    placeholder="Select Date"
                    // value={day}
                    value={props.calenderDate.day}
                    disabled
                    // value={props.formData ? props.formData.val[val.name] : null}
                  />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label>Year</Label>
                  <Input
                    type="text"
                    placeholder="Select Date"
                    // value={year}
                    value={props.calenderDate.year}
                    disabled
                    // value={props.formData ? props.formData.val[val.name] : null}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Button type="submit" color="" className="btn-admin-settings">
              {props.button}
            </Button>{" "}
            &nbsp;
            <Button color="" className="btn-cancel" onClick={props.toggle}>
              Cancel
            </Button>
          </Col>
        </Row>
      
      </Form>
    </Fragment>
  );
};

export default FormAddHolidayCalender;
